import api from "./api";
import types from "./types";

import { request } from "api/apiSaga";
import {
    call,
    delay,
    put,
    // put,
    takeEvery,
    takeLatest,
} from "redux-saga/effects";
import { AnyAction } from "redux";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";

function* fetchLive(action: AnyAction) {
    while (true) {
        yield call(request, api.fetchLive, action);
        yield delay(20000);
    }
}

function* fetchQR(action: AnyAction) {
    yield call(request, api.fetchQR, action);
}

function* fetchActivities(action: AnyAction) {
    yield call(request, api.fetchActivities, action);
}

function* getAvailability(action: AnyAction) {
    yield call(request, api.getAvailability, action);
}

function* getDayAvailability(action: AnyAction) {
    yield call(request, api.getDayAvailability, action);
}

function* getTableAvailability(action: AnyAction) {
    yield call(request, api.getTableAvailability, action);
}

function* getGameAvailability(action: AnyAction) {
    yield call(request, api.getGameAvailability, action);
}

function* checkout(action: AnyAction): any {
    const response = yield call(request, api.checkout, action, "post");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("games.saga.content.checkout"),
            })
        );
    }
}

function* contact(action: AnyAction): any {
    const response = yield call(request, api.contact, action, "post");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("games.saga.content.contact"),
            })
        );
    }
}

function* calculate(action: AnyAction): any {
    yield call(request, api.calculate, action, "post");
}

export default function* saga() {
    yield takeLatest(types.GET_AVAILABILITY_REQUEST, getAvailability);
    yield takeLatest(types.FETCH_ACTIVITIES_REQUEST, fetchActivities);
    yield takeLatest(types.GET_DAY_AVAILABILITY_REQUEST, getDayAvailability);
    yield takeLatest(
        types.GET_TABLE_AVAILABILITY_REQUEST,
        getTableAvailability
    );
    yield takeLatest(types.CONTACT_REQUEST, contact);
    yield takeLatest(types.CHECKOUT_REQUEST, checkout);
    yield takeLatest(types.CALCULATE_REQUEST, calculate);
    yield takeEvery(types.GET_GAME_AVAILABILITY_REQUEST, getGameAvailability);
    yield takeEvery(types.FETCH_LIVE_REQUEST, fetchLive);
    yield takeEvery(types.FETCH_QR_REQUEST, fetchQR);
}
